export default function SizeGuideViewModel() {
    let tabs = ['Small', 'Medium', 'Large', 'XLarge'];
    this.sizeTabs = ko.observableArray([]);
    for (var i = 0; i < tabs.length; i++) {
        this.sizeTabs.push(new SizeTab(tabs[i], i == 0));
    }

    this.ClickTab = function (tab, data) {
          // Declare all variables
        var i, tabcontent, tablinks;

        // Get all elements with class="tabcontent" and hide them
        tabcontent = document.getElementsByClassName("tab-content");
        for (i = 0; i < tabcontent.length; i++) {
            tabcontent[i].style.display = "none";
        }

        // Get all elements with class="tablinks" and remove the class "active"
        tablinks = document.getElementsByClassName("tab__tab-button");
        for (i = 0; i < tablinks.length; i++) {
            tablinks[i].className = tablinks[i].className.replace(" active", "");
        }

        // Show the current tab, and add an "active" class to the button that opened the tab
        document.getElementById(tab.size).style.display = "block";
        data.target.className += " active";
    };
    this.Reserve = function (e) {
        localStorage.setItem('tab', e);
    };

    return this;
}

var SizeTab = function (size, active) {
    this.size = size;
    this.active = active;
};